import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Utils } from 'core/utils';

import { DialogComponent } from '../dialog.component';

@Component({
    selector: 'image-quality-dialog',
    templateUrl: './image-quality-dialog.component.html',
    styleUrls: [
        './image-quality-dialog.component.scss',
        '../dialog.scss',
    ],
    standalone: false
})
export class ImageQualityDialogComponent extends DialogComponent
{
  public imageQualityRating: string;

  constructor(@Inject(MAT_DIALOG_DATA) protected dialogData: any)
  {
    super(dialogData);
    this.imageQualityRating = dialogData.imageQualityRating || 'good';
  }

  public get imageUrl(): string
  {
    return Utils.url(
        `./assets/img/img-quality-popup-${this.imageQualityRating}.png`);
  }
}
